import { createReducer, PayloadAction } from "@reduxjs/toolkit";

import { IProject } from "Model/Storage/IProject";
import {
  projectDeleteSuccess,
  projectsAdd,
  projectsClear,
  projectsDeleteNext,
  projectsUpdateSuccess
} from "Store/Actions";
import { hasNoElements } from "Utils/Array";
import { isNullOrWhiteSpace } from "Utils/String";

export const list = createReducer<Record<string, IProject>>(
  {},
  {
    [projectsAdd.type]: (state, { payload }: PayloadAction<IProject[]>) => addProjectList(state, payload),
    [projectsClear.type]: () => ({}),
    [projectsUpdateSuccess.type]: (state, { payload }: PayloadAction<IProject[]>) => addProjectList(state, payload),
    [projectsDeleteNext.type]: (state, { payload }: PayloadAction<string>) => removeProject(state, payload),
    [projectDeleteSuccess.type]: (state, { payload }: PayloadAction<string>) => removeProject(state, payload)
  }
);

function addProjectList(state: Record<string, IProject>, projectList: IProject[]): Record<string, IProject> {
  if (hasNoElements(projectList)) {
    return state;
  }

  const newState = { ...state };
  for (const project of projectList) {
    const id = project[`@id`];
    newState[id] = project;
  }

  return newState;
}

function removeProject(state: Record<string, IProject>, id: string): Record<string, IProject> {
  if (isNullOrWhiteSpace(id)) {
    return state;
  }

  if (Object.hasOwnProperty.call(state, id) === false) {
    return state;
  }

  const newState = { ...state };
  delete newState[id];
  return newState;
}
